/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, Input, OnInit } from '@angular/core';
import { ButtonResult, IButtonResult, ITextButton, isDisabled } from './sysque-text-button-types';
import { finalize, isObservable } from 'rxjs';

@Component({
  selector: 'sysque-text-button',
  templateUrl: './sysque-text-button.component.html',
  styleUrls: ['./sysque-text-button.component.scss'],
  standalone: false
})
export class SysqueTextButtonComponent<T extends IButtonResult | void> implements OnInit {
  @Input() button: ITextButton<T>;

  public isPrimary?: boolean;

  public get name(): string {
    return this.button.name;
  }

  public get width(): string {
    return this.button.width;
  }

  public get isDisabled(): boolean {
    return isDisabled(this.button) || this.isClickBusy;
  }

  public get isBordered(): boolean {
    return this.button.isBordered;
  }

  public get hasImage(): boolean {
    return !!this.button.imageSrc;
  }

  public get imageSrc(): string {
    return this.button.imageSrc;
  }

  private isClickBusy = false;

  public ngOnInit(): void {
    this.setImmutableFields();
  }

  public onButtonClick(): void {
    const click$ = this.button.click();
    if (isObservable(click$)) {
      this.isClickBusy = true;
      click$.pipe(finalize(() => (this.isClickBusy = false))).subscribe((result) => this.handleClickResult(result));
    } else {
      this.handleClickResult(click$);
    }
  }

  public setImmutableFields(): void {
    this.isPrimary = this.button.isPrimary;
  }

  public handleClickResult(result: ButtonResult): void {
    if (result && result.title !== undefined) {
      this.button.title = result.title;
    }
  }
}
